export enum HoardingStatusEnum {
    AVAILABLE = "Available",
    BLOCKED = "Blocked",
    INACTIVE = "Inactive",
    NOT_AVAILABLE = "Not-Available",
    EXPIRED = "Expired",
    MIGRATED = "Migrated",
    INVALID = "Invalid"
}
